var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.9122 2.58203H10.101C5.38641 2.58203 2.5835 5.38495 2.5835 10.0866V20.8979C2.5835 25.5995 5.38641 28.4024 10.0881 28.4024H20.8993C25.601 28.4024 28.4039 25.5995 28.4039 20.8979V10.0866C28.4168 5.38495 25.6139 2.58203 20.9122 2.58203Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 10.9553H11.3279L11.7542 10.529C12.1288 10.1544 12.1288 9.53443 11.7542 9.15984C11.3796 8.78526 10.7596 8.78526 10.385 9.15984L8.35711 11.1878C7.98253 11.5623 7.98253 12.1823 8.35711 12.5569L10.385 14.5848C10.5788 14.7786 10.8242 14.869 11.0696 14.869C11.315 14.869 11.5604 14.7786 11.7542 14.5848C12.1288 14.2103 12.1288 13.5903 11.7542 13.2157L11.4184 12.8798H17.98C19.6334 12.8798 20.9896 14.2232 20.9896 15.8894C20.9896 17.5557 19.6463 18.899 17.98 18.899H11.625C11.0954 18.899 10.6563 19.3382 10.6563 19.8678C10.6563 20.3973 11.0954 20.8365 11.625 20.8365H17.98C20.7054 20.8365 22.9271 18.6148 22.9271 15.8894C22.9271 13.164 20.7054 10.9553 17.98 10.9553Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSquare);
export default __webpack_public_path__ + "static/media/back-square.4cdc1a96d762e643a0fbd1de1831422e.svg";
export { ForwardRef as ReactComponent };